import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../input-base/input-base';

const INPUT_SELECT_VALUE_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	// eslint-disable-next-line @typescript-eslint/no-use-before-define, no-use-before-define
	useExisting: forwardRef(() => InputSelectComponent),
	multi: true,
};

@Component({
	selector: 'app-input-select',
	templateUrl: './input-select.component.html',
	styleUrls: ['../input-base/input-styles.scss', './input-select.component.scss'],
	providers: [INPUT_SELECT_VALUE_ACCESSOR],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InputSelectComponent extends InputBase implements ControlValueAccessor {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input({ required: true }) options!: any[];

	@Input() valueProp = 'value';

	@Input() textProp = 'text';

	getOptionText(option: any) {
		return this.getOptionProp(option, this.textProp);
	}

	getOptionValue(option: any) {
		return this.getOptionProp(option, this.valueProp);
	}

	private getOptionProp(option: any, prop: string) {
		if (typeof option === 'string') {
			return option;
		}
		return option?.[prop] ? option[prop] : String(option);
	}
}
